// Ported from horizontal-actions-dashboard/frontend/src/components/StatusBadge.tsx,
// translated from CSS custom properties to MUI Chip styling.

import { Chip } from '@mui/material';
import type { Applicable, Status } from '../../api/horizontalActionsTypes';
import { STATUS_LABELS } from '../../utils/horizontalActionsFormat';

const STATUS_STYLES: Record<Status, { bg: string; fg: string }> = {
  completed: { bg: '#e8f5e9', fg: '#1e7e34' },
  in_progress: { bg: '#e3f2fd', fg: '#0d47a1' },
  not_started: { bg: '#f1f1f1', fg: '#616161' },
  blocked_or_attention: { bg: '#fdecea', fg: '#c0392b' },
  unknown: { bg: '#fff8e1', fg: '#8a6d00' },
};

export function TerminalsStatusBadge({ status }: { status: Status }) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.unknown;
  return (
    <Chip
      size="small"
      label={STATUS_LABELS[status] ?? status}
      sx={{ backgroundColor: style.bg, color: style.fg, fontWeight: 600 }}
    />
  );
}

const APPLICABLE_LABELS: Record<Applicable, string> = {
  applicable: 'Applicable',
  not_applicable: 'Not applicable',
  unknown: 'Applicability unknown',
};

export function TerminalsApplicableBadge({ applicable }: { applicable: Applicable }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={APPLICABLE_LABELS[applicable] ?? applicable}
      sx={{ color: '#5a6b7c', borderColor: '#cfd8dc' }}
    />
  );
}
